/* esm.sh - d3-transition@3.0.1/src/transition/selection */
import{selection as t}from"d3-selection";var o=t.prototype.constructor;function e(){return new o(this._groups,this._parents)}export{e as default};
//# sourceMappingURL=selection.mjs.map